import React from 'react';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Checkbox } from './ui/checkbox';
import { Textarea } from './ui/textarea';

// The four prospect fields shared by products and packages. Newsdesk's
// Prospects inbox offers only what is marked "Show to prospects", describes
// it with these words, and links the store page. Prices always come from the
// product rate or package price, never from these descriptions.
export const PROSPECT_DEFAULTS = {
  show_to_prospects: false,
  prospect_description_en: '',
  prospect_description_es: '',
  store_url: '',
};

export const prospectState = (item) => ({
  show_to_prospects: !!item?.show_to_prospects,
  prospect_description_en: item?.prospect_description_en || '',
  prospect_description_es: item?.prospect_description_es || '',
  store_url: item?.store_url || '',
});

export const prospectPayload = (v) => ({
  show_to_prospects: !!v.show_to_prospects,
  prospect_description_en: (v.prospect_description_en || '').trim() || null,
  prospect_description_es: (v.prospect_description_es || '').trim() || null,
  store_url: (v.store_url || '').trim() || null,
});

const ProspectFields = ({ value, onChange, testid = 'prospect' }) => {
  const set = (patch) => onChange({ ...value, ...patch });
  return (
    <div className="p-3 bg-[#0A0A0A] border border-[#1E293B] rounded-md space-y-3" data-testid={`${testid}-fields`}>
      <p className="text-[11px] uppercase tracking-wide text-[#94A3B8]">Prospects (Newsdesk)</p>
      <label className="flex items-center gap-2 cursor-pointer">
        <Checkbox
          checked={!!value.show_to_prospects}
          onCheckedChange={(checked) => set({ show_to_prospects: !!checked })}
          data-testid={`${testid}-show-checkbox`}
        />
        <span className="text-sm text-[#F8FAFC]">Show to prospects</span>
      </label>
      <p className="text-[11px] text-[#475569] pl-6">
        Newsdesk may offer this in replies to ad prospects, at the rate set here.
      </p>
      {value.show_to_prospects && (
        <>
          <div className="space-y-1">
            <Label className="text-[#94A3B8] text-xs">Description for prospects (English)</Label>
            <Textarea
              rows={2}
              value={value.prospect_description_en}
              onChange={(e) => set({ prospect_description_en: e.target.value })}
              placeholder="e.g. Full-colour full page in the print edition, 12,000-16,000 copies every two weeks"
              className="bg-[#121212] border-[#1E293B] text-[#F8FAFC] text-sm"
              data-testid={`${testid}-description-en`}
            />
          </div>
          <div className="space-y-1">
            <Label className="text-[#94A3B8] text-xs">Description for prospects (Spanish, optional)</Label>
            <Textarea
              rows={2}
              value={value.prospect_description_es}
              onChange={(e) => set({ prospect_description_es: e.target.value })}
              placeholder="Left empty, Newsdesk translates the English one"
              className="bg-[#121212] border-[#1E293B] text-[#F8FAFC] text-sm"
              data-testid={`${testid}-description-es`}
            />
          </div>
          <div className="space-y-1">
            <Label className="text-[#94A3B8] text-xs">Store link (optional)</Label>
            <Input
              value={value.store_url}
              onChange={(e) => set({ store_url: e.target.value })}
              placeholder="https://store.gringogazette.com/product/…"
              className="bg-[#121212] border-[#1E293B] text-[#F8FAFC] h-9 text-sm"
              data-testid={`${testid}-store-url`}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default ProspectFields;
